import React from 'react';
import { history } from '../GMARouter';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/Avatar';

export const GeneralErrorPage = () => {
  return (
    <div className="h-screen w-full bg-gamma-bg-primary flex justify-center items-center flex-col">
      <div className="w-1/4 h-1/4 flex justify-center items-center flex-col gap-6">
        <Avatar className="w-[100px] h-[100px]">
          <AvatarImage src="/icons/errorRobot.png" />
          <AvatarFallback>
            <span className="material-symbols-outlined text-[48px] text-white">error</span>
          </AvatarFallback>
        </Avatar>

        <div className="flex flex-col gap-4 items-center justify-center">
          <p className="font-graphik text-white text-base not-italic font-semibold leading-4">WHOOPS!</p>

          <p className="text-white text-center text-sm not-italic font-normal leading-[21px]">
            An unexpected error has occurred. Please return to the homepage to continue.
          </p>
        </div>

        <button
          className="flex justify-center items-center gap-8 p-2 rounded-lg bg-white hover:bg-opacity-80"
          onClick={() => {
            history.push('/'); // return home
          }}
        >
          <p className="text-gamma-bg-primary text-sm not-italic font-semibold leading-[110%] tracking-[-0.28px];">
            HOMEPAGE
          </p>
        </button>
      </div>
    </div>
  );
};
